

































import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryOrderAllocateErrorRecordList,QueryOrderAllocateErrorRecordCount } from '@/api'
import { DateFormat,DateFormat2 } from '@/utils/date/DateUtil'
import constant from '@/utils/constant'
import OrderDescDialog from './OrderDescDialog.vue'
import { Message, MessageBox } from 'element-ui'
import {getUser} from '@/store/userStore'
import UserWealthRecordDialog from '@/views/user/components/UserWealthRecordDialog.vue'
import { OrderAllocateErrorStatusFormat, OrderAllocateErrorTypeFormat } from '@/utils/tyepconvert'
import AllocateErrorDialog from './componetns/AllocateErrorDialog.vue'

@Component({
  components: {
    VQuery,
    VTable,
    OrderDescDialog,
    UserWealthRecordDialog,
    AllocateErrorDialog,
  },
})
export default class AllocateErrorRecord extends Vue {
  private queryParam: any = {
    // orderType: 0,
    startRow: 1,
    limit: 10,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1
  private selectData: Array<any> = []

  private user = getUser()

  private activeMenu: any = 'wait'
  private orderCounts = {}
  private shopIdOption: Array<any> = []
  private shopIdQueryParam: QueryModel = { title: '店铺', param: 'shopId' , type: 'select', selectData:  this.shopIdOption,show:()=>{return this.user.user.role != 2}}

  // 查询条件
  private queryModels: Array<QueryModel> = [
    // { title: '订单类型', param: 'orderType', type: 'select', selectData: constant.OrderType },
    this.shopIdQueryParam,
    { title: '订单编号', param: 'orderCode' },
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [
  ]
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '订单编号', param: 'orderCode', overflow: true,width:200 },
    { title: '分佣类型', param: 'allocateType', overflow: true,width:200, formatter: OrderAllocateErrorTypeFormat },
    { title: '执行状态', param: 'status', overflow: true,width:200, formatter: OrderAllocateErrorStatusFormat },
    { title: '执行次数', param: 'count',width:100 },
    { title: '首次错误时间', param: 'createTime',formatter: DateFormat },
    { title: '最后一次错误时间', param: 'userId', formatter: DateFormat },
    {
      title: '操作',
      width: 280,
      fixed: 'right',
      operation: [
        { title: '查看错误日志', click: (data) => this.openDialog('AllocateErrorDialog', {...data}) },
        { title: '订单详情', icon: 'el-icon-document', click: (data) => this.openDialog('OrderDescDialog', {...data}) },
        { title: '积分发放情况', click: this.openWealthRecord, show: ()=>{return this.user.user.role != 2} },
      ],
    },
  ]

  // 打开积分流水
  public openWealthRecord(data:any){
    const d = this.$refs.UserWealthRecordDialog as UserWealthRecordDialog
    d.open({recordNo: data.orderCode})
  }


  private pageActiveMenu:any = undefined
  public activated(){
    const am = this.$route.query.activeMenu
    console.log(am)
    if(this.pageActiveMenu != am){
      // 如果路由的菜单不一致则刷新
      this.activeMenu = am
      this.loadData()
    }

  }
  public async created() {
    const am = this.$route.query.activeMenu
    if(am){
      this.activeMenu = am
    }
    this.loadData()
  }

  //。选择菜单
  private activeMenuSelect(e:string){
    if(this.activeMenu == e){
      return
    }
    this.activeMenu = e
    this.search()
    let hideRefundStatus = true
    if(e == 'refund'){
      hideRefundStatus = false
    }
    this.tableHander.forEach(e=>{
        if(e.param == 'refundStatus'){
          e.hide = hideRefundStatus;
        }
      })
  }

  private getRequestParam(){
    const param = { ...this.queryParam }
    param.startRow = (this.tableCurrntPage - 1) * (param.limit || 12)


    // 根据选择菜单的不同查询不同的数据
    if(this.activeMenu == 'wait'){
      // 执行异常
      param.status = 0
    }else if(this.activeMenu == 'error'){
      // 严重执行执行异常
      param.status = 0
      param.countGe = 6
    }else if(this.activeMenu == 'finish'){
      // 执行成功
      param.status = 1
    }
    return param
  }

  public async loadData() {
    const param = this.getRequestParam()

    const result = await QueryOrderAllocateErrorRecordList(param)
    this.tableTotal = result.total
    this.tableData = result.list

    const resCounts = await QueryOrderAllocateErrorRecordCount(param)
    this.orderCounts = resCounts

  }

  public search() {
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }

  private selectChange(selection: any) {
    this.selectData = selection
  }

  private openDialog(dia: string, data?: any) {
    const f = this.$refs[dia] as any
    f.open(data)
  }

}
